import React, { useState, useEffect } from 'react';
import './HomeAboutSection.css';
import Button from "../Button/Button";

const HomeAboutSection = ({ link, title, details, buttonText, images }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Automatically cycle through images every 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000);

    return () => clearInterval(interval); // Cleanup on unmount
  }, [images.length]);

  return (
    <div className="HomeAboutSection-container">
      <div className="HomeAboutSection-left">
        <h1 className='HomeAboutSection-title'>{title}</h1>
        <p className='HomeAboutSection-details'>{details}</p>
        <Button to={link} children={buttonText}/>
      </div>
      <div className="HomeAboutSection-right">
        <div className="HomeAboutSection-image-container">
          <img
            src={images[currentImageIndex]}
            alt={title}
            className="HomeAboutSection-image"
          />
        </div>
      </div>
    </div>
  );
};

export default HomeAboutSection;
